// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"917":"5a786b41","3486":"2674036f","6856":"8716c76a"}[chunkId] + ".chunk.css";
};